import { createContext } from 'react';
import noop from 'lodash/noop';

type FocusRestorationContextType = {
	shouldRestoreFocusRef: { current: boolean }; // remove shouldRestoreFocusRef on cleanup of jfp-magma-fix-project-nav-move-focus-restoration
	shouldRestoreFocus: boolean;
	enableRestoreFocus: () => void;
	clearRestoreFocus: () => void;
};

export const FocusRestorationContext = createContext<FocusRestorationContextType>({
	shouldRestoreFocusRef: { current: false },
	shouldRestoreFocus: false,
	enableRestoreFocus: noop,
	clearRestoreFocus: noop,
});
